const ElementPrototype = (window.Element || Node || window.HTMLElement)
  .prototype;

ElementPrototype.$emit = function (name, detail = {}) {
  this.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail,
    }),
  );
  return this;
};

ElementPrototype.$on = function (name, cb) {
  this.addEventListener(name, cb, false);
  return cb;
};

ElementPrototype.$once = function (name, cb) {
  var wrapper = function () {
    this.removeEventListener(name, wrapper, false);
    cb.apply(this, arguments);
  };
  this.addEventListener(name, wrapper, false);
  return wrapper;
};
